import type { ReactNode } from 'react';
import { Monitor, Moon, Sun } from 'lucide-react';
import { useThemeStore, type ThemeChoice } from '@/store/themeStore';

const OPTIONS: readonly { choice: ThemeChoice; label: string; Icon: typeof Sun }[] = [
  { choice: 'light', label: 'Светлая тема', Icon: Sun },
  { choice: 'dark', label: 'Тёмная тема', Icon: Moon },
  { choice: 'system', label: 'Как в системе', Icon: Monitor },
];

/** Three buttons rather than a cycling toggle: the current choice is readable
 *  without pressing anything, which matters when "system" looks like "light". */
export function ThemeSwitch(): ReactNode {
  const choice = useThemeStore((state) => state.choice);
  const setChoice = useThemeStore((state) => state.setChoice);

  return (
    <div className="segmented" role="group" aria-label="Оформление">
      {OPTIONS.map(({ choice: option, label, Icon }) => (
        <button
          key={option}
          type="button"
          title={label}
          aria-label={label}
          aria-pressed={choice === option}
          onClick={() => setChoice(option)}
        >
          <Icon size={15} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
